<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<div class="toc1">
<p class="toc_h">CONTENTS</p>
</div>
<p class="toc" id="raut"><span href="#/text/About_the_Author#aut" title="Link target outside of Sample">About the Author</span></p>
<p class="toc" id="rack"><span href="#/text/Acknowledgements#ack" title="Link target outside of Sample">Acknowledgements and Sources</span></p>
<p class="tocs" id="rch1"><a href="#/text/Chapter01#ch1">Chapter 1</a></p>
<p class="toc" id="rch2"><a href="#/text/Chapter02#ch2">Chapter 2</a></p>
<p class="toc" id="rch3"><span href="#/text/Chapter03#ch3" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc" id="rch4"><span href="#/text/Chapter04#ch4" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc" id="rch5"><span href="#/text/Chapter05#ch5" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc" id="rch6"><span href="#/text/Chapter06#ch6" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc" id="rch7"><span href="#/text/Chapter07#ch7" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc" id="rch8"><span href="#/text/Chapter08#ch8" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc" id="rch9"><span href="#/text/Chapter09#ch9" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc" id="rch10"><span href="#/text/Chapter10#ch10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc" id="rch11"><span href="#/text/Chapter11#ch11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc" id="rch12"><span href="#/text/Chapter12#ch12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc" id="rch13"><span href="#/text/Chapter13#ch13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc" id="rch14"><span href="#/text/Chapter14#ch14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc" id="rch15"><span href="#/text/Chapter15#ch15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc" id="rch16"><span href="#/text/Chapter16#ch16" title="Link target outside of Sample">Chapter 16</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?75fe366a